
const decisionState = (state = false, action) => {
    if(action.type === 'CLOSE_DECISION')
    {
        return true;
    } else if (action.type === 'OPEN_DECISION') {
        return false;
    } else {
        return state;
    }
    
}

export default decisionState;